import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { buildLandingHtml, AI_PLACEHOLDER } from "@/pages/tmc/landingTemplate";

export default function PublicPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, html: null, err: false });
  useEffect(() => {
    let on = true;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/landing/public/${encodeURIComponent(slug)}`)
      .then((r) => {
        if (!on) return;
        const d = r.data || {};
        const isAi = d.page_type === "ai" || d.mode === "ai";
        const html = isAi ? (d.ai_html || AI_PLACEHOLDER) : buildLandingHtml(d);
        setState({ loading: false, html, err: false });
      })
      .catch(() => { if (on) setState({ loading: false, html: null, err: true }); });
    return () => { on = false; };
  }, [slug]);

  if (state.loading)
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#08060f" }}>
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: "#a855f7" }} />
      </div>
    );
  if (state.err) return <Navigate to="/" replace />;
  return (
    <iframe title="The Money Club" srcDoc={state.html} data-testid="public-landing-frame"
      style={{ border: 0, width: "100vw", height: "100vh", display: "block" }} />
  );
}
